<template>
  <div id="page">
    <div id="outer">
      <div id="title-div">
        <div id="allSpan-div">
          <div id="span-div1">
            <span id="title-span">
              世界前1000名大学
            </span>
          </div>
        </div>

        <div id="select-banner" style="margin-right: 56px;">
              <el-form :model="form" inline style="display: flex;align-items: center;" label-width="80px">
                <el-form-item label="院校名称" style="display: flex;">
                  <el-input placeholder="请输入院校名称" v-model="form.collegeName" @keyup.enter.native="qian1000List()" clearable=""></el-input>
                </el-form-item>
                <el-form-item label="国家" style="display: flex;">
                  <el-select v-model="form.country" filterable placeholder="全部" clearable @change="qian1000List()">
                  <el-option
                    v-for="item in countryArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                </el-form-item>
                <el-form-item style="display: flex;">
                  <el-button type="success" size="small" @click="qian1000List()">查询</el-button>
                </el-form-item>
              </el-form>
        </div>
      </div>
      <div style="width:90%;height: 78%;overflow-y: auto;margin: 0 auto;">
        <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}"
          v-loading="loading">
          <el-table-column prop="collegeName" label="学校名称" align="center">
          </el-table-column>
          <el-table-column prop="country" label="国家名称" align="center">
          </el-table-column>
          <el-table-column prop="sort_id" label="世界排名" align="center">
          </el-table-column>
          <el-table-column prop="country_sort" label="学校排名" align="center">
          </el-table-column>
        </el-table>
        </div>

    </div>
  </div>
</template>

<script>
import { qian1000List } from "@/api/gw/zonghe.js";
export default {
  data() {
    return {
      list: [],
      total:0,
      form: {
        collegeName: "", //学校名称
        country: "", //国家
      },
      loading: true,
      countryArr:[
        "阿根廷","阿联酋","埃及","埃塞俄比亚","爱尔兰","爱沙尼亚","奥地利","澳大利亚","巴基斯坦","巴西",
        "比利时","冰岛","波兰","丹麦","德国","俄罗斯","法国","芬兰","哥伦比亚","韩国","荷兰","加拿大","加纳",
        "捷克","卡塔尔","克罗地亚","黎巴嫩","立陶宛","卢森堡","马来西亚","美国","墨西哥","南非","挪威","葡萄牙",
        "日本","瑞典","瑞士","塞尔维亚","塞浦路斯","沙特阿拉伯","斯洛伐克","斯洛文尼亚","泰国","突尼斯","土耳其","西班牙",
        "希腊","新加坡","新西兰","匈牙利","伊朗","以色列","意大利","印度","英国","约旦","智利","中国","中国澳门","中国台湾","中国香港"
      ]
    };
  },
  mounted() {
    this.qian1000List();
  },
  methods: {
    qian1000List() {
      this.loading = true;
      qian1000List(this.form)
        .then((res) => {
          this.list = res.data
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/comprehensive/components/qian.vue